import {
	APPROVE_USERS_ENDPOINT,
	BASE_URL,
	GET_REGISTERED_USERS_ENDPOINT,
	HTTP_OK,
	HTTP_STATUS_SUCCESS,
	STATIC_API_KEYS,
	UPDATE_USER_ENDPOINT,
} from "../../utils/constants";
import { getBaseUrl } from "../../utils/utils";
import {
	approveUserBegin,
	approveUserFailure,
	approveUserSuccess,
	fetchUsersBegin,
	fetchUsersFailure,
	fetchUsersSuccess,
	updateUserBegin,
	updateUserFailure,
	updateUserSuccess,
} from "../registrations";
import { apiGet, apiPost, apiPut } from "./api";

export const fetchRegisteredUsers = () => async (dispatch, getState) => {
	await dispatch(fetchUsersBegin());

	try {
		const { status, data } = await dispatch(
			apiGet(`${getBaseUrl()}${GET_REGISTERED_USERS_ENDPOINT}`, {
				headers: {
					"x-api-key": STATIC_API_KEYS.admin,
				},
			})
		);

		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(fetchUsersSuccess({ data: response.data, status }));

				return true;
			} else {
				await dispatch(fetchUsersFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(fetchUsersFailure({ message: JSON.stringify(e) }));

		return false;
	}
};

export const approveOrRejectRegisteredUser = (payload) => async (dispatch, getState) => {
	await dispatch(approveUserBegin());

	try {
		const { status, data } = await dispatch(
			apiPut(`${getBaseUrl()}${APPROVE_USERS_ENDPOINT}`, {
				body: payload,
				headers: {
					"x-api-key": STATIC_API_KEYS.admin,
				},
			})
		);
		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(approveUserSuccess({ data, status }));

				return true;
			} else {
				await dispatch(approveUserFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(approveUserFailure({ message: JSON.stringify(e) }));

		return false;
	}
};

export const updatedRegisteredUser = (payload) => async (dispatch, getState) => {
	await dispatch(updateUserBegin());

	try {
		const { status, data } = await dispatch(
			apiPut(`${getBaseUrl()}${UPDATE_USER_ENDPOINT}/${payload.id}`, {
				body: payload,
				headers: {
					"x-api-key": STATIC_API_KEYS.admin,
				},
			})
		);
		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(updateUserSuccess({ data, status }));

				return true;
			} else {
				await dispatch(updateUserFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(updateUserFailure({ message: JSON.stringify(e) }));

		return false;
	}
};
